const elementIsNotNULL = function (object) {
    if (object) {
        return true;
    }
    return false;
};
export default elementIsNotNULL;
